<template>
    <div :class="['panel', wrapperClass]">
      <div v-if="title" class="panel-title title">{{ title }}</div>
      <div class="content">
        <slot />
      </div>
      <!-- 
        <div class="content">
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Animi beatae reprehenderit culpa sunt sit, id, aspernatur vitae accusantium molestias eius quod possimus dolore mollitia autem nesciunt porro facere nemo vero.
      </div>
      <h4 class="inner-title">部屋数</h4>
      <div class="content">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis, perspiciatis! Natus officia a facilis quae necessitatibus ipsam maxime, delectus reiciendis vitae et commodi ducimus aliquid dolor officiis, aliquam ipsum distinctio?
      </div>
     -->
    </div>
</template>
  
<script>
export default {
    name: 'Panel',
    props: {
        title: {
            type: String,
            default: ''
        },
        wrapperClass: {
            type: String,
            default: ""
        }
    }
}
</script>
<style lang="scss" scoped>
@import "./styles.scss";
</style>  